import { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { ReportCategory, ReportDefinition } from '@drivingdoc/shared-types/reports';

import { ErrorResponse, privateApi } from 'api';

export interface GetReportsParams {
  category?: ReportCategory;
}

export interface GetReportsResult {
  reports: ReportDefinition[];
}

async function getReports(params: GetReportsParams | undefined): Promise<GetReportsResult> {
  const queryParams = params?.category ? `?category=${params.category}` : '';
  const result = await privateApi.get<GetReportsResult>(
    `${import.meta.env.VITE_API_BASE_URL}/reports${queryParams}`
  );
  return result.data;
}

const useGetReports = createQuery<GetReportsResult, GetReportsParams, AxiosError<ErrorResponse>>({
  queryKey: ['reports'],
  fetcher: (variables) => getReports(variables),
});

export { getReports, useGetReports };
